
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_3n5mc_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_3n5mc_1",
  "root": "awsui_root_mgja0_3n5mc_120",
  "focus-lock": "awsui_focus-lock_mgja0_3n5mc_134",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_3n5mc_138",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_3n5mc_142",
  "calendar-container": "awsui_calendar-container_mgja0_3n5mc_146",
  "one-grid": "awsui_one-grid_mgja0_3n5mc_149",
  "calendar-header": "awsui_calendar-header_mgja0_3n5mc_153",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_3n5mc_159",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_3n5mc_159",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_3n5mc_180",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_3n5mc_183",
  "first-grid": "awsui_first-grid_mgja0_3n5mc_187",
  "second-grid": "awsui_second-grid_mgja0_3n5mc_188",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_3n5mc_192",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_3n5mc_198",
  "footer": "awsui_footer_mgja0_3n5mc_205",
  "has-clear-button": "awsui_has-clear-button_mgja0_3n5mc_212",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_3n5mc_219",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_3n5mc_226",
  "label": "awsui_label_mgja0_3n5mc_231",
  "label-enabled": "awsui_label-enabled_mgja0_3n5mc_236",
  "label-text": "awsui_label-text_mgja0_3n5mc_240",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_3n5mc_245",
  "mode-switch": "awsui_mode-switch_mgja0_3n5mc_249",
  "dropdown": "awsui_dropdown_mgja0_3n5mc_253",
  "dropdown-content": "awsui_dropdown-content_mgja0_3n5mc_269",
  "start-date-input": "awsui_start-date-input_mgja0_3n5mc_278",
  "start-time-input": "awsui_start-time-input_mgja0_3n5mc_279",
  "end-date-input": "awsui_end-date-input_mgja0_3n5mc_280",
  "end-time-input": "awsui_end-time-input_mgja0_3n5mc_281",
  "validation-section": "awsui_validation-section_mgja0_3n5mc_285",
  "validation-error": "awsui_validation-error_mgja0_3n5mc_289",
  "clear-button": "awsui_clear-button_mgja0_3n5mc_293",
  "apply-button": "awsui_apply-button_mgja0_3n5mc_297",
  "cancel-button": "awsui_cancel-button_mgja0_3n5mc_301",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_3n5mc_305"
};
  